import { render, staticRenderFns } from "./CreateMember.vue?vue&type=template&id=0b1ccc19&scoped=true"
import script from "./CreateMember.vue?vue&type=script&lang=js"
export * from "./CreateMember.vue?vue&type=script&lang=js"
import style0 from "./CreateMember.vue?vue&type=style&index=0&id=0b1ccc19&prod&scoped=true&lang=css"
import style1 from "./CreateMember.vue?vue&type=style&index=1&id=0b1ccc19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ccc19",
  null
  
)

export default component.exports